import { render } from "./super-master.vue?vue&type=template&id=1a6ac9b2"
import script from "./super-master.vue?vue&type=script&lang=js"
export * from "./super-master.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__